export const normalizeToZero = (value = 0) => {
	return value < 0 ? 0 : value;
};
